var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFiambresElaborados = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40942 4.0016C5.40942 4.0016 13.1861 4 15.612 4C16.2624 3.99947 16.907 4.13814 17.5077 4.40698C19.1869 5.18533 22.0739 7.1894 21.994 11.91C21.917 16.4569 19.2969 18.5672 17.6453 19.4481C16.9682 19.8073 16.223 19.9943 15.468 19.9943C12.9509 19.9996 5.74527 19.9996 5.74527 19.9996",
    fill: "#C62828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.931 11.9542C21.931 11.9542 21.8516 9.94219 23.3375 9.92944C24.8229 9.91669 23.5718 11.9027 21.931 11.9542Z",
    fill: "#C62828",
    fillOpacity: 0.98
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9232 11.8447C21.9232 11.8447 23.7908 11.7582 23.8034 13.359C23.8159 14.9592 21.9719 13.6123 21.9232 11.8447Z",
    fill: "#C62828",
    fillOpacity: 0.98
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40868 4.00181C5.40868 4.00181 11.443 3.8387 11.2383 11.9102C11.0337 19.9818 5.74452 19.9998 5.74452 19.9998C5.74452 19.9998 -0.0363219 20.1486 0.000172063 11.9102C0.0366661 3.67188 5.40868 4.00181 5.40868 4.00181Z",
    fill: "#EF9A9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91534 10.9145C3.46362 10.9145 3.90808 10.4356 3.90808 9.84496C3.90808 9.25429 3.46362 8.77545 2.91534 8.77545C2.36707 8.77545 1.92261 9.25429 1.92261 9.84496C1.92261 10.4356 2.36707 10.9145 2.91534 10.9145Z",
    fill: "#EEEEEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78061 12.3304C8.19016 12.3304 8.52217 11.9727 8.52217 11.5315C8.52217 11.0903 8.19016 10.7326 7.78061 10.7326C7.37107 10.7326 7.03906 11.0903 7.03906 11.5315C7.03906 11.9727 7.37107 12.3304 7.78061 12.3304Z",
    fill: "#EEEEEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28467 15.1796C6.56168 15.1796 6.78625 14.9377 6.78625 14.6393C6.78625 14.3408 6.56168 14.0989 6.28467 14.0989C6.00765 14.0989 5.78308 14.3408 5.78308 14.6393C5.78308 14.9377 6.00765 15.1796 6.28467 15.1796Z",
    fill: "#EEEEEE"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFiambresElaborados, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FiambresElaborados.744704a7.svg";
export { ForwardRef as ReactComponent };